(() => {
  if (customElements.get('me-paypal-message-loader')) return;
  const loads = new Map();
  function load(url) {
    if (!loads.has(url)) {
      loads.set(url, new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = url;
        script.async = true;
        script.dataset.namespace = 'mePayPalMessages';
        script.onload = () => resolve(window.mePayPalMessages);
        script.onerror = () => { loads.delete(url); script.remove(); reject(new Error('PayPal messages unavailable')); };
        document.head.append(script);
      }));
    }
    return loads.get(url);
  }
  class PayPalMessageLoader extends HTMLElement {
    connectedCallback() {
      this.target = this.nextElementSibling?.querySelector('[data-pp-message]');
      if (!this.target) return;
      this.productInfo = this.closest('.product-info');
      this.onVariantChange = (event) => {
        if (!this.productInfo?.contains(event.target)) return;
        const price = event.detail?.variant?.price;
        this.target.parentElement.hidden = !Number.isFinite(price) || price >= 1000000;
        if (Number.isFinite(price)) this.target.dataset.ppAmount = String(price / 100);
      };
      this.productInfo?.addEventListener('on:variant:change', this.onVariantChange);
      if (this.started) return;
      if (!('IntersectionObserver' in window)) { this.start(); return; }
      this.observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) this.start();
      }, { rootMargin: '200px' });
      this.observer.observe(this.target.parentElement);
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.productInfo?.removeEventListener('on:variant:change', this.onVariantChange);
    }
    async start() {
      if (this.started) return;
      this.started = true;
      this.observer?.disconnect();
      try {
        const sdk = await load(this.dataset.sdkUrl);
        if (this.isConnected && sdk?.Messages) await sdk.Messages().render(this.target);
      } catch (error) {
        this.started = false;
      }
    }
  }
  customElements.define('me-paypal-message-loader', PayPalMessageLoader);
})();
